/**
 * Create jQuery children of data-node
 * @example

 * @param {string|jQuery} elm - string id or jQuery id element
 * @returns {object} jQuery datepicker object
 */
$_GP.fn.dataNode = function(elm) {
	elm = $(elm);
	if (!elm.length) return;
	elm = elm.eq(0);
	const nodeExt = elm.data('node')

	return {
		el(nodeName) {
			return elm.find(`[data-node-${nodeExt}="${nodeName}"]`)
		}
	}
};
